module.exports = __webpack_public_path__ + "static/media/whyus4.14de49d9.png";